export default "__VITE_ASSET__CIMaskbF__"